import { SubscriptionData } from 'owa-premium-subscription';
import addDays from 'date-fns/add_days';
import { officeTokenEndYear } from 'owa-premium-subscription';
import { getUserConfiguration } from 'owa-session-store';
import { getUserSubscription } from 'owa-premium-subscription';
import { fetchUserSubscription } from 'owa-premium-subscription';
import { isFlightPersisted } from 'owa-premium-flight';
import { persistUserFlight } from 'owa-premium-flight';

export async function isInPremiumSupportFlight(flightName: string) {
    let userConfiguration = getUserConfiguration();

    if (
        userConfiguration.SessionSettings.IsPremiumConsumerMailbox &&
        userConfiguration.SessionSettings.UserCulture === 'en-US'
    ) {
        let isFlightEnabledBefore = await isFlightPersisted(flightName);

        if (isFlightEnabledBefore) {
            return true;
        } else {
            let subscription = await getUserSubscription();
            if (subscription == null) {
                subscription = await fetchUserSubscription();
            }
            let isSubNearExpiring = isSubscriptionNearExpiring(subscription.subscriptions);

            if (isSubNearExpiring) {
                await persistUserFlight(flightName);
            }

            return isSubNearExpiring;
        }
    }

    return false;
}

export function isSubscriptionNearExpiring(subscriptions: SubscriptionData[]): boolean {
    const today = new Date();
    for (let i = 0; i < subscriptions.length; i++) {
        const subscription: SubscriptionData = subscriptions[i];
        const subscriptionExpireDate: Date = new Date(subscription.subscriptionExpireDate);
        if (
            subscription.brandId.toLowerCase() === 'office' &&
            subscriptionExpireDate.getFullYear() != officeTokenEndYear &&
            !subscription.autoRenew &&
            !subscription.isSuppressedOfferId
        ) {
            if (
                subscription.subscriptionStatus.toLowerCase() === 'enabled' &&
                subscriptionExpireDate > today &&
                addDays(subscriptionExpireDate, -30) < today
            ) {
                return true;
            }
        }
    }
    return false;
}
